<template>
  <div>
    <div class="confirm-modal-block">
      <div class="confirm-modal-header-block">
        <p class="confirm-modal-header">
          {{ header }}
        </p>
        <p class="confirm-modal-subheader">
          {{ subheader }}
        </p>
      </div>
      <button class="confirm-modal-go-back-button" @click="close">
        {{ $resourceString["virtualtray.too.much.items.alert.button"] }}
      </button>
    </div>
    <button
      class="confirm-modal-close-button wf-modal-button-close btn button-full"
      type="button"
      @click="close"
    >
      <span
        class="confirm-modal-close-label png-icon png-icon-icons-symbols--k-txtclose"
        aria-label="Close modal"
      />
    </button>
  </div>
</template>

<script>
export default {
		props: ['header','subheader','close'],
  data() {
    return {};
  },
};
</script>

<style>
</style>